import React from 'react'
import { StdHeroInner, StdHeroWrapper } from '@styles/modules/heroImages'
import Img, { FluidObject } from 'gatsby-image'
import { IMAGELOADINGENUMS } from '@et/types/Enums'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { IGatsbyChildImageSharp, IGatsbyImageDataObject } from '@et/types/Gatsby'
import styled from 'styled-components'
import CtaButton from '@components/buttons/ctaButton'
import { device } from '@styles/global/breakpoints'

interface IProps {
  img: IGatsbyImageDataObject
  alt: string
  backgroundColor?: string | null
  classes?: string,
}

function StandardHeroImgV4 ({ backgroundColor = null, img, alt, classes = '' }: IProps) {
  return (
    <StdHeroWrapper backgroundColor={backgroundColor}>
      <StdHeroInner>
        <Custom className={classes} >
          <GatsbyImage alt={alt} image={img.gatsbyImageData} loading={IMAGELOADINGENUMS.LAZY} />
        </Custom>
        <ButtonWrapper>
          <CtaButton id={'mini-card'} text={'Enroll for Free!'}  />
        </ButtonWrapper>
      </StdHeroInner>
    </StdHeroWrapper>
  )
}
export default StandardHeroImgV4

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);

  @media ${device.tablet}{
    bottom: 55px;
  }

  button{
    padding: 12px 25px;
    margin: 15px 0 5px;
    border-radius: 50px;
    background: ${props => props.theme.highlight.i500};
    border: ${props => props.theme.highlight.i500};
    color: #fff;
    font-weight: 700;
    transition: .3s;
    font-size: 18px;
    width: 220px;
    text-align: center;
    justify-content: center;
    
    span{
      margin-left: 20px;
    }
    &:hover{
      color: #fff;
      cursor: pointer;
      background: ${props => props.theme.highlight.i300};
    }
  }
  
`
const Custom = styled.div`
  &.mb-10{
    padding: 0 0 100px 0;
  }
`
